import { useState } from "react";

interface UseDragDropProps {
  onMoveValue: (valueId: string, targetCategory: number) => void;
  onMoveAllChecked: (targetCategory: number) => void;
  checked: { [key: string]: boolean };
  selectedCategory: number;
}

export const useDragDrop = ({
  onMoveValue,
  onMoveAllChecked,
  checked,
  selectedCategory,
}: UseDragDropProps) => {
  const [dragOverCategory, setDragOverCategory] = useState<number | null>(null);

  const handleDragStart = (
    e: React.DragEvent<HTMLDivElement>,
    valueId: string,
  ) => {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", valueId);
  };

  const handleDragOver = (
    e: React.DragEvent<HTMLDivElement>,
    categoryId: number,
  ) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setDragOverCategory(categoryId);
  };

  const handleDragLeave = () => {
    setDragOverCategory(null);
  };

  const handleDrop = (
    e: React.DragEvent<HTMLDivElement>,
    targetCategory: number,
  ) => {
    e.preventDefault();
    const valueId = e.dataTransfer.getData("text/plain");
    if (valueId && targetCategory !== selectedCategory) {
      // Check if the dragged item is checked
      if (checked[valueId]) {
        // If checked, move all checked items

        onMoveAllChecked(targetCategory);
      } else {
        // If not checked, move only this item
        onMoveValue(valueId, targetCategory);
      }
    }
    setDragOverCategory(null);
  };

  const getCategoryBackground = (categoryId: number) => {
    if (dragOverCategory === categoryId) return "#b2dfdb";
    if (selectedCategory === categoryId) return "#e0f2f1";
    return undefined;
  };

  return {
    dragOverCategory,
    handleDragStart,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    getCategoryBackground,
  };
};

const useDragDropHook = useDragDrop;
export default useDragDropHook;
